<div *ngIf="showLoader" class="loader">
  <mat-spinner strokeWidth="3" diameter="100" color="#000"></mat-spinner>
</div>

<div class="background">
  <div class="backimage">
    <button type="button" (click)="backButtonNavigate()" class="backbtn">
      Back
    </button>
  </div>
  <div class="headertext">
    Test Slip ID {{ testSlipDetails?.smthTestSlipDetailed.testSlipId }}
  </div>
  <div *ngIf="testSlipDetails?.smthTestSlipDetailed.status === 1">
    <input type="button" class="buttonclass" value="SUBMITTED" />
  </div>
  <div *ngIf="testSlipDetails?.smthTestSlipDetailed.status === 2">
    <input type="button" class="buttonapprovedclass" value="APPROVED" />
  </div>
  <div *ngIf="testSlipDetails?.smthTestSlipDetailed.status === 3">
    <input type="button" class="buttonreviewclass" value="IN REVIEW" />
  </div>
  <div *ngIf="testSlipDetails?.smthTestSlipDetailed.status === 4">
    <input type="button" class="buttonretestlass" value="SENT TO RETEST" />
  </div>
  <div *ngIf="testSlipDetails?.smthTestSlipDetailed.status === 8">
    <input type="button" class="buttonhandoverpendingclass" value="HANDOVER PENDING" />
  </div>
  <div>
    <span
      class="material-icons exporthelp"
      [matTooltipPosition]="'above'"
      matTooltip="Expand required panel before exporting."
    >
      info_outline
    </span>
    <input
      type="button"
      class="downloadbutton"
      (click)="exportToPDF()"
      value="EXPORT TO PDF"
    />
  </div>

  <!-- // test Slip Status start -->
  <div class="container-fluid p-5">
    <div class="row p-3" *ngFor="let associatedSlip of associatedSlips;">
      <div class="smthover" *ngIf="associatedSlip != null">
        <div class="smthoverslip">
          <img
            src="assets/images/download.png"
            class="download"
            alt="up arrow"
          /><span class="handover"
            >{{ associatedSlip.associatedMessage }}</span
          >

          <button
            type="button"
            (click)="viewAssociatedNavigate(associatedSlip)"
            class="associatebtn"
          >
            View associated test slip
          </button>
        </div>
      </div>
    </div>

    <div class="row p-3 ml-2" id="fullData">
      <!-- // left side -->
      <div class="col-lg-6" id="left-sidepanel">
        <div class="hidden__headertext" id="testSlipId">
          Test Slip ID {{ testSlipDetails?.smthTestSlipDetailed.testSlipId }}
        </div>
        <div class="p-3" id="testSlipStatustab">
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            [expanded]="true"
          >
            <mat-expansion-panel-header>
              <mat-panel-title class="headertesttext">
                Test Slip Status
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="status">
              <table #dataTable class="table table-striped">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      class="w-30"
                      (click)="sortData('statusName')"
                    >
                      STATUS
                    </th>
                    <th
                      scope="col"
                      class="w-30"
                      (click)="sortData('modifiedDate')"
                    >
                      UPDATED ON
                    </th>
                    <th scope="col">UPDATED BY</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of smthAuditTrails; let i = index">
                    <td>
                      <div *ngIf="item?.statusName">
                        
                        <span class="columnStatus">{{ item.statusName  | titlecase }}</span> &nbsp;
                        <span *ngIf="item.status === 9 || (item.status === 4)"
                        class="material-icons statusIcon"
                        [matTooltipPosition]="'above'"
                        matTooltip="{{item.sendToName}}  &nbsp;  / &nbsp;  {{item.sendToMail}}"
                      >
                        info_outline
                      </span>
    
                      </div>
                    </td>
                    <td>
                      <span class="columnModify">{{
                        item?.modifiedDate | dateFormat: "dd/MM/yyyy, HH:mm"
                      }}</span>
                    </td>
                    <td>
                      <span class="columnModify"
                        >{{ item?.modifiedByName }} </span
                      ><br />
                      <span class="emailFont">{{ item?.modifiedByEmail }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>
        </div>
        <div class="p-3" id="testSlipDetailstab">
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            [expanded]="true"
          >
            <mat-expansion-panel-header>
              <mat-panel-title class="headertesttext">
                Test Slip Details
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="backgroundWhite slip-details-container">
              <div class="slip-label">Fault Number</div>
              <div class="slip-detail-value">
                {{ testSlipDetails?.smthTestSlipDetailed.faultNo }}
              </div>

              <div class="slip-label">Work Order Number</div>

              <div class="slip-detail-value">
                {{ testSlipDetails?.smthTestSlipDetailed.workorderNo }}
              </div>

              <div class="slip-label">Site of work</div>
              <div class="slip-detail-value">
                {{ testSlipDetails?.smthTestSlipDetailed.site }}
              </div>

              <div class="slip-label">Equipment</div>
              <div class="slip-detail-value">
                {{ testSlipDetails?.smthTestSlipDetailed.assetId }}
              </div>

              <div class="slip-label">Depot</div>

              <div class="slip-detail-value">
                {{ testSlipDetails?.smthTestSlipDetailed.depot }}
              </div>

              <div class="slip-label">Details of work</div>
              <div class="slip-detail-value">
                {{ testSlipDetails?.smthTestSlipDetailed.workDetails }}
              </div>

              <div class="slip-label">SMTH Plan(s) executed</div>

              <div class="slip-detail-value">
                {{ testSlipDetails?.smthTestSlipDetailed.testPlan }}
              </div>

              <div class="slip-label">Name(s) of person(s) doing the work</div>
              <div class="slip-detail-value">
                {{ testSlipDetails?.smthTestSlipDetailed.workers }}
              </div>

              <div class="slip-label">Name of person Doing the testing</div>
              <div class="slip-detail-value">
                {{ testSlipDetails?.smthTestSlipDetailed.testerName }}
              </div>

              <div class="slip-label">Associated with SFI testing</div>
              <div class="slip-detail-value">
                {{ testSlipDetails?.smthTestSlipDetailed.isSFI ? "Yes" : "No" }}
              </div>

              <div class="slip-label">Relevant Notes</div>
              <div class="slip-detail-value">
                {{ testSlipDetails?.smthTestSlipDetailed.comments }}
              </div>
              <ng-container *ngIf="!isPaperTestslip">
                <div class="slip-label">Handed over to</div>
                <div class="slip-detail-value">
                  {{ testSlipDetails?.smthTestSlipDetailed.handoverUser }}
                  <br />
                  {{ handOverName?.email }}
                </div>
              </ng-container>
            </div>
          </mat-expansion-panel>
        </div>

        <div class="p-3" id="testPlanPhotostab">
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            [expanded]="true"
            *ngIf="!isPaperTestslip"
          >
            <mat-expansion-panel-header>
              <mat-panel-title class="headertesttext">
                Relevant Photos
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>
            <div *ngIf="smthFiles">
              <div class="section" *ngFor="let image of albums; let i = index">
                <img
                  class="relevantPhotos"
                  [src]="image.thumb"
                  (click)="open(i, 'albums')"
                />
              </div>
            </div>
          </mat-expansion-panel>
        </div>

        <div class="p-3" id="testPlanCommenttab">
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            [expanded]="true"
          >
            <mat-expansion-panel-header>
              <mat-panel-title class="headertesttext">
                Comments
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div
              *ngFor="let comments of commentValueData; let i = index"
              class="comments-box"
            >
              <div class="comments-details">
                <div class="comments-by">
                  {{ comments.commentedByName }} |
                  {{
                    comments.commentedDate | dateFormat: "dd MMM yyyy, HH:mm"
                  }}
                </div>

                <div *ngIf="comments.userValue === true && !isReadOnly" class="edit-btn">
                  <button
                    class="edit-comment"
                    (click)="editCommentValue(i, comments)"
                  ></button>
                </div>

                <div *ngIf="comments.userValue === true && !isPaperTestslip && !isReadOnly">
                  <button
                    class="delete-comment"
                    (click)="deleteCommentValue(comments)"
                  ></button>
                </div>

                <div *ngIf="comments.valueAdded === true" class="editMode">
                  <button
                    class="save-comment"
                    [disabled]="comments.comments === '' || !commentsChanged"
                    (click)="editUpdateValue(comments, $event)"
                  ></button>

                  <button
                    class="cancel-comment"
                    (click)="cancelComment(comments, $event)"
                  ></button>
                </div>
              </div>

              <div class="read-only" *ngIf="!editcomments">
                <textarea
                  class="edittextarea"
                  cols="71"
                  [ngClass]="{ highlight: comments.valueAdded === false }"
                  (ngModelChange)="commentChanged($event)"
                  [(ngModel)]="comments.comments"
                  (blur)="editUpdate(comments, $event)"
                  >{{ comments.comments }}</textarea
                >
              </div>

              <div class="read-only" *ngIf="editcomments">
                <textarea
                  readonly
                  class="edittextarea"
                  cols="71"
                  [ngClass]="{ highlightValue: comments.valueAdded === false }"
                  >{{ comments.comments }}</textarea
                >
              </div>
              <div class="files-list" *ngFor="let file of comments?.smthFiles;let i= index">
                <div class="name">{{ file.fileName }}</div>
                <div class="download-file" (click)="downloadFile(file)" *ngIf="!isReadOnly">
                  <img src="assets/icons/Download.svg">
                </div>
              </div>
            </div>
            <div class="files-list-container" *ngIf="files.length != 0">
              <div class="files-list" *ngFor="let file of files;let i= index">
                {{ file.name }}
                <button class="delete-file" (click)="deleteAttachment(i)">
                  <img src="./assets/images/Delete.png">
                </button>
              </div>
            </div>
            <div class="add-comment" id="addComments" *ngIf="enableAddComments && !isReadOnly">
              <div>Add Comment</div>

              <div>
                <textarea
                  class="comment-textarea"
                  rows="4"
                  cols="71"
                  [disabled]="!enableAddComments"
                  name="comment"
                  [(ngModel)]="comments"
                ></textarea>
              </div>

              <div
                class="test-slip-actions"
                *ngIf="
                  enableChangeREviewStatus && (testSlipDetails.smthTestSlipDetailed.status === 1 || testSlipDetails.smthTestSlipDetailed.status === 8) && 
                  handleApproveinHandover()
                "
              >
                <div class="row">
                  <div class="col" *ngIf="!sameUserLogged">
                    <input
                      type="checkbox"
                      [(ngModel)]="notifySubmitter"
                      class="form-control chk-box"
                      aria-label="notifySubmitter"
                    />

                    <label for="notifySubmitter" class="chk-box-label"
                      >Notify the test-slip submitter</label
                    >
                  </div>
                </div>

                <div class="row" *ngIf="reviewAccess && userHasAccess">
                  <div class="col" *ngIf="!sameUserLogged">
                    <input
                      type="checkbox"
                      [(ngModel)]="chkInReview"
                      class="form-control chk-box"
                      aria-label="changeStatusInReview"
                    />

                    <label for="changeStatusInReview" class="chk-box-label"
                      >Change status to “IN REVIEW”</label
                    >
                  </div>
                </div>
              </div>

              <div class="comment-btn">
                <button
                  type="button"
                  (click)="addComment()"
                  [disabled]="(comments === '' && files.length === 0) || !enableAddComments"
                  class="btn btn-add-comment"
                >
                  Submit
                </button>
                <div class="uploadfilecontainer">
                  <input hidden type="file" multiple #fileInput
                    (change)="uploadFile($event.target)">
                  <div class="innter-container">
                    <button type="button" (click)="fileInput.click()" class="btn btn-upload-document">
                      Attach Document
                    </button>
                  </div>
                </div>
              </div>
              <div class="email-section" *ngIf="showButtons == 0 && !sameUserLogged && approverEmail">
                <div class="nr-subsection">{{ approverEmailLabel }}</div>
                <div class="nr-search-box" [formGroup]="userConfig">
                  <input matInput type="search" class="form-control" aria-label="State" formControlName="name" [matAutocomplete]="auto"/>
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayProperty">
                    <mat-option *ngFor="let state of filteredUsers | async" [value]="state">
                      <span>{{state.displayName }} - {{state.jobTitle}}</span>
                    </mat-option>
                  </mat-autocomplete>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
        <div id="buttonBox" class="buttonbox" *ngIf="showButtons === 0 && !isReadOnly">
          <div class="btn-row">
            <button
              type="button"
              (click)="approveTestSlip()"
              class="btn btn-default btn-submit btn-row-col"
              *ngIf="!sameUserLogged && isThirdLevel && handleApproveinHandover()"
            >
              Approve
            </button>

            <button
              type="button"
              (click)="sendForRetest()"
              class="btn btn-default btn-reset btn-row-col"
              *ngIf="!sameUserLogged && testSlipDetails.smthHandover?.handedOverTo == null"
            >
              Send to re-test 
            </button>

            <button 
              type="button"
              (click)="forwardHandover()"
              class="btn btn-default btn-reset"
              *ngIf="!sameUserLogged && isUnKnown()  && !handoverDone">
                Assign to Technician
            </button>
          </div>
          <div class="btn-row" *ngFor="let approver of approvalLevel">
            <div class= "btn-row-col" *ngFor="let btns of approver.buttons">
              <button
              type="button"
              (click)="approveTestSlip(approver)"
              class="btn btn-default btn-submit column"
              *ngIf="!sameUserLogged && isSFI && !btns.email"
            >
              {{ btns.label }}
            </button>
            <button
              type="button"
              (click)="sendToNextLevelApproval(approver, btns.id)"
              class="btn btn-default btn-submit"
              [disabled]="userConfig.invalid"
              *ngIf="!sameUserLogged && isSFI && btns.email"
            >
              {{ btns.label }}
            </button>
            </div>
          </div>
        </div>
      </div>

      <!-- // left side -->

      <div class="col-lg-6 overflow-hidden" id="right-sidepanel">
        <div id="test-executiontabs">
          <div class="p-3" *ngFor="let plan of testPlanListItems; let i = index">
            <div class="testplan" id="testPlanExecutiontab_{{ i }}">
              <mat-expansion-panel
                (opened)="panelOpenState = true"
                (closed)="panelOpenState = false"
                [expanded]="true"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title class="headertesttext">
                    Test Plan Execution ({{ plan.smthTestPlanName }}) -
                    {{ plan.smthTestPlansDescription }}
                  </mat-panel-title>
                  <mat-panel-title class="headertesttext hiddentext" hidden>
                    Tester ({{
                      testSlipDetails?.smthTestSlipDetailed.testerName
                    }}
                    )
                  </mat-panel-title>
                  <mat-panel-description> </mat-panel-description>
                </mat-expansion-panel-header>
                <div
                  id="serialNoBody_{{ i }}"
                  *ngIf="testSlipDetails.smthTestSlipSerialNumbers"
                >
                  <div
                    *ngFor="
                      let serialNumber of testSlipDetails.smthTestSlipSerialNumbers;
                      let i = inxed
                    "
                  >
                    <div
                      class="serialNoBody w-95"
                      *ngIf="plan.smthTestPlanId == serialNumber.testPlanId"
                    >
                      <div class="">
                        <div class="col-5 bgSNum m-3">
                          <div class="sNolabel">Old Serial Number</div>
                          <div class="sNo-value">
                            {{ serialNumber.oldSerialNumber }}
                          </div>
                        </div>
                        <div class="col-5 bgSNum m-3">
                          <div class="sNolabel">New Serial Number</div>
                          <div class="sNo-value">
                            {{ serialNumber.newSerialNumber }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="slipDetails_{{ i }}" class="slip-details">
                  <div
                    class="BodyCOntainer border-top slipDetails_class_{{ i }}"
                    id="innerslipDetails_{{ i }}_{{ j }}"
                    *ngFor="let q of plan.smthTestPlans; index as j"
                  >
                    <div class="Container1">
                      <div class="sub_heading" *ngIf="j === 0">{{ q.stepType }}</div>
                      <div
                        class="sub_heading"
                        *ngIf="j > 0 && plan.smthTestPlans[j - 1].stepType != q.stepType"
                      >
                        {{ q.stepType }}
                      </div>
                        <div class="sub_heading" *ngIf="q.subSection" [innerHTML]="q.subSection | safe: 'html'"></div>
                        <div class="step-container">
                        <div class="d-flex">
                          <span class="asterix" *ngIf="q.asterix == 1">*</span>
                          <div
                            [ngClass]="{
                              'rag-amber': q.rag == 'Amber',
                              'rag-red': q.rag == 'Red',
                              'rag-green': q.rag == 'Green'
                            }"
                            class="content-span"
                          >
                            <div class="sequence">
                              <label class="OrderProperty">
                                {{ q.label + "." }}
                              </label>
                            </div>
                            <div class="QuestionContainer">
                              <div
                                class="QuestionProperty"
                                [innerHTML]="q.question | safe: 'html'"
                              ></div>
                            </div>
                            <span [ngClass]="{ new: q.new == 'Yes' }"></span>
                          </div>
                        </div>

                        <div class="answer-container">
                          <div *ngIf="q.answer" class="d-flex">
                            <div *ngIf="showButton(q, 1)">
                              <img
                                class="yesno"
                                src="assets/images/yes.svg"
                                *ngIf="q.answer != 1"
                              />

                              <img
                                class="yesno"
                                src="assets/images/yes-active.svg"
                                *ngIf="q.answer == 1"
                              />
                            </div>

                            <div *ngIf="showButton(q, 2)" class="Imgcls">
                              <img
                                class="yesno"
                                src="assets/images/no.svg"
                                *ngIf="q.answer != 2"
                              />

                              <img
                                class="yesno"
                                src="assets/images/no-active.svg"
                                *ngIf="q.answer == 2"
                              />
                            </div>
                          </div>

                          <div class="check-container" *ngIf="q.answer && showButton(q, 3)">
                            <img
                              class="check"
                              src="assets/images/checkbox-unchecked.svg"
                              *ngIf="q.answer != 3"
                            />

                            <img
                              class="check"
                              src="assets/images/checkbox-checked.svg"
                              *ngIf="q.answer == 3"
                            />

                            <span class="NotApplicable">N/A</span>
                          </div>

                          <div class="answers" *ngIf="!q.answer">
                            <span class="activeLabel"
                              >Handed over to
                              {{
                                testSlipDetails?.smthTestSlipDetailed
                                  .handoverUser
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="Container2">
                      <div class="Container2Property" *ngIf="q.answer == 2">
                        <div class="QuestionProperty">
                          <label class="ReasonContainer">
                            Reason for not executing the step
                          </label>
                        </div>
                        <div class="QuestionProperty">
                          <label
                            ><b>{{ q.comments }}</b></label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Digital Wire Count-->
                <div
                  class="border-top"
                  *ngIf="
                    wireCountText(
                      testSlipDetails.smthTestSlipWireCountDTO,
                      plan.smthTestPlanId
                    )
                  "
                  id="digitalWireCounttab_{{ i }}"
                >
                  <h3
                    *ngIf="wireCountAlbum?.length > 0"
                    class="wirecount-header"
                  >
                    Wirecount
                  </h3>
                  <div
                    *ngFor="
                      let wireCount of filteredWireCountDTO(
                        plan.smthTestPlanId
                      );
                      let k = index
                    "
                    id="wireCount_{{ i }}_{{ k }}"
                    [class.wireCountData]="wireCount.fileData !== null"
                  >
                    <div
                      class=""
                      *ngIf="plan.smthTestPlanId == wireCount.testPlanId"
                    >
                      <div *ngIf="wireCount.digitalWireCount !== null">
                        <app-wire-count-data
                          [dwcdata]="wireCount"
                          id="wireCountHead_{{ i }}_{{ k }}_3"
                          class="wcForm"
                        ></app-wire-count-data>

                        <div>
                          <app-digital-wire-count-component
                            *ngIf="wireCount.beforeInstallationWireCount"
                            title="Before Installation"
                            [formType]="wireCount.beforeInstallationFormType"
                            [(testData)]="wireCount.beforeInstallationWireCount"
                            [tSCount]="i"
                            [wcCount]="k"
                            [wct]="1"
                            id="wireCountHead_{{ i }}_{{ k }}_1"
                            class="wcForm"
                          ></app-digital-wire-count-component>

                          <app-digital-wire-count-component
                            *ngIf="wireCount.digitalWireCount !== null"
                            [formType]="wireCount.formType"
                            [(testData)]="wireCount.digitalWireCount"
                            [title]="
                              wireCount.beforeInstallationWireCount
                                ? 'After Installation'
                                : 'Before and After Installation'
                            "
                            [tSCount]="i"
                            [wcCount]="k"
                            [wct]="2"
                            id="wireCountHead_{{ i }}_{{ k }}_2"
                            class="wcForm"
                          ></app-digital-wire-count-component>
                        </div>
                      </div>
                      <div
                        *ngIf="wireCount.fileData !== null"
                        id="wireCountFile_{{ i }}_{{ k }}"
                        class="wireCountFile_{{ i }}_{{ k }} wcForm picture_wirecount"
                      >
                      <h3 class="headertesttext">Step Number - {{wireCount.stepNumber}}</h3>
                        <img
                            class="picture-wirecount relevantPhotos"
                            [src]="wireCount.fileData"
                            (click)="open(k, 'wireCountAlbum')"
                          />
                      </div>
                    </div>
                  </div>
                </div>
                <!--Permutation Chart-->
                <div
                  class="border-top"
                  *ngIf="
                    wireCountText(
                      testSlipDetails.smthTestSlipPermutationDTO,
                      plan.smthTestPlanId
                    )
                  "
                  id="digitalPermutationChartTab_{{ i }}"
                >
                  <div class="wirecount-header">Permutation Chart</div>
                  <div
                    *ngFor="
                      let permutationChart of testSlipDetails.smthTestSlipPermutationDTO;
                      let x = index
                    "
                  >
                    <div
                      class="w-95"
                      *ngIf="plan.smthTestPlanId == permutationChart.testPlanId"
                    >
                      <div class="serialNoBody w-95">
                        <app-permutation-chart-component
                          *ngIf="permutationChart.digitalPermutation !== null"
                          [(testData)]="permutationChart.digitalPermutation"
                          [tSCount]="i"
                        ></app-permutation-chart-component>
                      </div>
                      <div *ngIf="permutationChart.fileData !== null">
                        <div
                          class="section"
                          *ngFor="
                            let image of permutationChartAlbum;
                            let i = index
                          "
                        >
                          <img
                            class="picture-wirecount relevantPhotos"
                            [src]="permutationChart.fileData"
                            (click)="open(i, 'permutationChartAlbum')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #approveDialog>
  <div class="title">
    <h1 matDialogTitle>SMTH Portal</h1>
  </div>
  
  <mat-dialog-content>
    <div class="message">
      <p> Enter reason for approving the partially completed handed over Test Slip.</p>
      <textarea [(ngModel)]="approvalReason"></textarea>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="pr-4">
    <button mat-button  class="btn btn-yes" [disabled]="!approvalReason"  [mat-dialog-close]="true" (click)="onConfirm()" >Approve</button>
    <button mat-button matDialogClose  class="btn btn-no" [mat-dialog-close]="true">Cancel</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #retestDialog>
  <div class="title">
    <h1 matDialogTitle>SMTH Portal</h1>
  </div>
  <!-- <button mat-icon-button class="close-button" matDialogClose>
    <mat-icon class="close-icon">close</mat-icon>
  </button> -->
  <mat-dialog-content class="pt-2">
    <div class="message">
      <mat-radio-group
      aria-label="Select an option"
      (change)="onRetestSelctionChange($event)"
    >
      <mat-radio-button  value="1" color="primary" class="pr-4" [checked]="sameTechnician"
        >Send to same Technician</mat-radio-button
      >
      <mat-radio-button value="2" color="primary" [checked]="!sameTechnician"
        >Send to a Different Technician</mat-radio-button
      >
      </mat-radio-group>
      <div *ngIf="!sameTechnician">
        <form [formGroup]="handoverForm">
          <div class="FormProperty">
            <label class="slip-label required" for="handoverName">Name of the person receiving the Re-test </label>
            <input matInput type="text" id="handoverName" class="form-control input-sm txt-input" #user aria-label="State" [matAutocomplete]="auto" formControlName="handoverTo" value="{{userName}}"/>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getuserData($event)" [displayWith]="displayName" >
              <mat-option *ngFor="let state of filteredUsers | async" [value]="state">
                <span >{{state.displayName }} - {{state.jobTitle}}</span>
              </mat-option>
            </mat-autocomplete>
            </div>
            <div class="FormProperty">
              <label class="slip-label" for="handoverEmail">E-mail of person receiving the Re-test</label>
              <input
              id="handoverEmail"
              type="text"
              class="form-control input-sm txt-input"
              [value]="selectedUser?.mail"
              formControlName="email"
            />
            </div>
        </form>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="pr-4">
    <button mat-button  class="btn btn-yes" [mat-dialog-close]="true" [disabled]="" (click)="onRetest()" >Send to re-test</button>
    <button mat-button matDialogClose  class="btn btn-no"  (click)="resetForm()" [mat-dialog-close]="true">Cancel</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #forwardToTechnician>
  <div class="title">
    <h1 matDialogTitle class="">SMTH Portal</h1>
  </div>
  <mat-dialog-content>
    <div class="message">
      <form [formGroup]="handoverForm">
        <div class="FormProperty">
          <label class="slip-label required" for="handoverName">Name of the person receiving the handover </label>
          <input matInput type="text" id="handoverName" class="form-control input-sm txt-input" #user aria-label="State" [matAutocomplete]="auto" formControlName="handoverTo" value="{{userName}}"/>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getuserData($event)" [displayWith]="displayName" >
            <mat-option *ngFor="let state of filteredUsers | async" [value]="state">
              <span >{{state.displayName }} - {{state.jobTitle}}</span>
            </mat-option>
          </mat-autocomplete>
          </div>
          <div class="FormProperty">
            <label class="slip-label" for="handoverEmail">E-mail of person receiving the handover</label>
            <input 
            id="handoverEmail"
            type="text"
            class="form-control input-sm txt-input"
            [value]="selectedUser?.mail"
            formControlName="email"
          />
          </div>
      </form>
    </div>
   </mat-dialog-content>
   <mat-dialog-actions align="end" class="pr-4">
    <button mat-button  class="btn btn-yes"   [mat-dialog-close]="true" [disabled]="!handoverForm.valid" (click)="onHandover()" >Handover</button>
    <button mat-button matDialogClose  class="btn btn-no" [mat-dialog-close]="true" (click)="resetForm()">Cancel</button>
  </mat-dialog-actions>
</ng-template>
